import { Button } from 'antd';
import { ChevronDown } from 'lucide-react';
import styled from 'styled-components';

export const ListActionsArea = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const ListActionsBarContainer = styled.div`
    background: ${({ theme }) => theme.colors.antdBackground};
    border: 1px solid ${({ theme }) => theme.colors.antdBorder};
    border-radius: 8px;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;

    @media only screen and (max-width: 768px) {
        align-items: stretch;
    }
`;

export const ListActions = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;

    @media only screen and (max-width: 768px) {
        width: 100%;
        flex-direction: column;
        align-items: stretch;
    }
`;

export const ListActionParamsArea = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    @media only screen and (max-width: 768px) {
        width: 100%;
        flex-wrap: wrap;

        & > * {
            flex: 1 1 100%;
            min-width: 0;
        }
    }
`;

export const ListActionButton = styled(Button)<{ $active?: boolean }>`
    display: flex;
    align-items: center;
    gap: 9px;
    height: 38px;
    font-weight: 500;
    font-size: 14px;
    border: 1px solid ${({ theme }) => theme.colors.antdBorder};
    color: ${({ theme }) => theme.colors.antdText};

    @media only screen and (max-width: 768px) {
        width: 100%;
    }

    &.ant-btn:focus .quantity,
    &.ant-btn:hover .quantity {
        background: ${({ theme }) => theme.colors.colorPrimaryHover};
        color: ${({ theme }) => theme.colors.white};
    }

    ${({ $active, theme }) =>
        $active &&
        `
      border-color: ${theme.colors.colorPrimaryHover};
      color: ${theme.colors.colorPrimaryHover};

      .quantity {
        background: ${theme.colors.colorPrimaryHover};
        color: ${theme.colors.white};
      }
    `}
`;

export const Chevron = styled(ChevronDown)<{ $active?: boolean }>`
    transition: transform 0.2s ease;

    transform: ${({ $active }) =>
        $active ? 'rotate(180deg)' : 'rotate(0deg)'};
`;

export const FilterQnt = styled.div`
    width: 18px;
    height: 18px;
    border-radius: 50%;
    color: ${({ theme }) => theme.colors.white};
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.colors.antdTextSecondary};
    font-size: 11px;
    transition: background 0.4s ease;
`;

export const ShowFiltersArea = styled.div<{ $active?: boolean }>`
    display: ${({ $active }) => ($active ? 'flex' : 'none')};
    align-items: center;
    gap: 8px;
`;
